<template>
    <SectionBase v-bind="$attrs" :section="section">
        <!-- Grid mode -->
        <template v-if="isGrid">
            <div :class="['ufo--columns', 'ufo--columns-' + visibleLogos.length]">
                <div v-for="(logo, index) in visibleLogos" :key="index" class="ufo--column">
                    <div class="ufo--column-content">
                        <div :class="['logo-box', unifiedClass, logoHoverClass, { gradient: isGradientBg }]"
                             :style="{ '--density': densityValue, '--logo-max-height': logoMaxHeight(logo) }">
                            <div class="media-container">
                                <ColumnImageHelper
                                    :index="index"
                                    :section="section"
                                    :columnMedia="logo"
                                    :placeholder-image="`${isCaseStudy ? '' : 'portfolio-'}empty-columns-0${index + 1}.${isCaseStudy ? 'jpg' : 'png'}`"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <!-- Carousel mode -->
        <template v-else>
            <LogoCarousel :section="section">
                <template #default="{ logo, index }">
                    <div class="media-container">
                        <ColumnImageHelper
                            :index="index"
                            :section="section"
                            :columnMedia="logo"
                            :placeholder-image="`${isCaseStudy ? '' : 'portfolio-'}empty-columns-0${(index % 4) + 1}.${isCaseStudy ? 'jpg' : 'png'}`"
                        />
                    </div>
                </template>
            </LogoCarousel>
        </template>
    </SectionBase>
</template>

<script>
import { mapGetters } from "vuex";
import SectionBase from "./SectionBase.vue";
import ColumnImageHelper from "./_helper/ColumnImageHelper.vue";
import LogoCarousel from "@/scripts/sections/common/LogoCarousel.vue";

export default {
    name: "LogoWall",
    components: { SectionBase, ColumnImageHelper, LogoCarousel },
    props: ["section"],
    computed: {
        ...mapGetters("design", ["resolveColor", "colorPalette"]),
        logoStyle() {
            return this.section?.logoStyle || {};
        },
        isGrid() {
            return (this.logoStyle.layout || "GRID") === "GRID";
        },
        visibleLogos() {
            return this.isGrid ? this.section.logos.slice(0, 5) : this.section.logos;
        },
        unifiedClass() {
            // Color reveal manages its own grayscale via CSS hover — skip unified class
            if (this.logoStyle.logoHoverInteraction === 'COLOR_REVEAL') return null;
            return this.logoStyle.unified ? 'unified' : null;
        },
        densityValue() {
            return this.logoStyle.density ?? null;
        },
        isGradientBg() {
            return (
                this.section.backgroundSettings?.selectedBackgroundStyleId !== null &&
                this.section.backgroundSettings?.selectedBackgroundStyleId > 1
            );
        },
        isCaseStudy() {
            return this.$store.getters.isCaseStudy;
        },
        logoHoverClass() {
            const interaction = this.logoStyle.logoHoverInteraction || "NONE";
            if (interaction === "COLOR_REVEAL") return "hover-color-reveal";
            if (interaction === "SCALE_UP") return "hover-scale-up";
            if (interaction === "OPACITY_INCREASE") return "hover-opacity-increase";
            return null;
        },
    },
    methods: {
        logoMaxHeight(logo) {
            const w = parseFloat(logo?.width);
            const h = parseFloat(logo?.height);
            return h > w ? '64px' : '32px';
        },
    },
};
</script>
